export const enum MediaTypeEnum {
  Video = "VIDEO",
  Image = "IMAGE",
}
